// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyDzCclBQ0u-u_x7UCJSzOZsdNxXQ2G_Aws",
    authDomain: "creative-agency-d8f1b.firebaseapp.com",
    projectId: "creative-agency-d8f1b",
    storageBucket: "creative-agency-d8f1b.appspot.com",
    messagingSenderId: "79526478981",
    appId: "1:79526478981:web:00b95f0a7a84e9059dd5ec"
  };
    // // Initialize Firebase
    // firebase.initializeApp(firebaseConfig);

export default firebaseConfig;    
